export default __webpack_public_path__ + "static/media/multicar11.530d0bf7.jpeg";